import { Injectable } from '@angular/core';
import { IconLinkConfig } from '@app/interfaces';

@Injectable({
  providedIn: "root",
})
export class IconLinkService {
  public configs: IconLinkConfig[] = [
    {
      iconClass: 'fa fa-external-link oa-orangered',
      openInNewTab: false,
      path: '/landowner/listing',
      title: 'Open listing admin page',
      id: 'open-listing-admin-page',
    },
    {
      iconClass: 'fa fa-external-link oa-orangered icon-link-new-tab',
      openInNewTab: true,
      path: '/landowner/listing',
      title: 'Open listing admin page in new tab',
      id: 'open-listing-admin-new-page',
    },

    {
      iconClass: 'fa fa-external-link oa-green',
      openInNewTab: false,
      path: '/listing',
      title: 'Open listing detail page in new tab',
      id: 'open-listing-detail-page',
    },
    {
      iconClass: 'fa fa-external-link oa-green icon-link-new-tab',
      openInNewTab: true,
      path: '/listing',
      title: 'Open listing detail page in new tab',
      id: 'open-listing-detail-new-page',
    },
  ];

  constructor() {}
}
